<template>
    <div class="search-input__wrap">
        <input
            class="input search-input"
            autocomplete="off"
            placeholder="Start Typing"
            aria-autocomplete="both"
            aria-label="Search USA Health"
            ref="input"
            @input="$emit('input', q)"
            @keyup="$emit('keyup', $event)"
            @keydown="$emit('keydown', $event)"
            v-model="q"
            type="search"
            name="search"
            :id="`search-${id}`"
            :aria-owns="`searchResults-${id}`"
            :aria-describedby="`searchDescription-${id}`"
        >
        <button :class="['button', '-link', 'search-input__clear']" type="button" @click="clearResults" aria-label="Clear search results" v-if="q.length && clearText">
            Clear
        </button>
        <span class="sr-only" :id="`searchDescription-${id}`">
            <!-- TODO: Get better wording -->
            Global site search.  By typing in the search input you can query all of the information available on the site and
            get instant relevant results from the first key stroke.  Results are segmented based on the types and are organized in tabs.
        </span>
    </div>
</template>

<script>
import $mediator from 'wee-mediator';

export default {
    props: {
        id: {
            type: Number,
        },
        clearText: {
            type: Boolean,
        },
    },
    mounted() {
        $mediator.on(`search-${this.id}.suggest`, (suggestion) => {
            this.q = suggestion;
            this.$refs.input.focus();
        });
    },
    methods: {
        clearResults() {
            $mediator.emit(`search-${this.id}.clear`);
            this.q = '';
        }
    },
    data: () => ({
        q:'',
    }),
}
</script>

